import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promo-codes',
  templateUrl: './promo-codes.component.html',
  styleUrls: ['./promo-codes.component.css']
})
export class PromoCodesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
